import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import FormationPage from './pages/FormationPages';

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* Navbar commune à toutes les pages */}
        <Navbar />
        {/* Contenu principal */}
        <div className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/formation" element={<FormationPage />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* Route catch-all : redirige vers la HomePage */}
            <Route path="/*" element={<HomePage />} />
          </Routes>
        </div>
        {/* Footer commun */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
